import { useTranslation } from 'gatsby-plugin-react-i18next'
import React from 'react'

import CloseArrow from '../../../images/close.svg'
import ModalSocial from './ModalSocial'

type Props = {
  onClose: () => void
}

const LaunchingSoonConfirmation: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()

  return (
    <>
      <button className="modal__close" onClick={onClose}>
        <img src={CloseArrow} />
      </button>
      <div className="modal__title">{t('Launching soon!')}</div>
      <div className="modal__description">
        <p>{t('You’re on the list. We will send you an invitation as soon as MealPal is live in your area!')}</p>
      </div>
      <ModalSocial />
    </>
  )
}

export default LaunchingSoonConfirmation
